import { render } from "./RxContent.vue?vue&type=template&id=22737192&scoped=true"
import script from "./RxContent.vue?vue&type=script&lang=js"
export * from "./RxContent.vue?vue&type=script&lang=js"

import "./RxContent.vue?vue&type=style&index=0&id=22737192&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22737192"]])

export default __exports__